import { render, staticRenderFns } from "./quotenotes-modal.vue?vue&type=template&id=4495a354&scoped=true&"
import script from "./quotenotes-modal.vue?vue&type=script&lang=tsx&"
export * from "./quotenotes-modal.vue?vue&type=script&lang=tsx&"
import style0 from "./quotenotes-modal.vue?vue&type=style&index=0&id=4495a354&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4495a354",
  null
  
)

export default component.exports